import 'css-chunksrc/client/scenes/taskStatus/status/form/styles.scss';export default {
  "form": "_form_si6ka_1",
  "iconBox": "_iconBox_si6ka_9",
  "icon": "_icon_si6ka_9",
  "group": "_group_si6ka_20",
  "input": "_input_si6ka_24",
  "colorPicker": "_colorPicker_si6ka_34"
};